module.exports = __webpack_public_path__ + "img/BOTTOMLEFT_LandedOn.ef2315d6.png";